import type { JSX } from "react";

import {
  Slider,
  SliderControl,
  SliderThumb,
  SliderTrack,
} from "@frontend/components/atoms/Slider";

import { useColorPickerContext } from "./ColorPicker.context";
import type { ColorPickerHueSliderProps } from "./ColorPicker.types";
import { hsvToHex } from "./colorMath";
import { HUE_TRACK_GRADIENT } from "./constants";

export function ColorPickerHueSlider({
  className,
}: ColorPickerHueSliderProps): JSX.Element {
  const { hsv, disabled, setHsv } = useColorPickerContext();

  return (
    <Slider
      data-slot="color-picker-hue-slider"
      className={className}
      min={0}
      max={360}
      value={hsv.h}
      disabled={disabled}
      onValueChange={(value) => setHsv({ h: value })}
    >
      <SliderControl>
        <SliderTrack style={{ backgroundImage: HUE_TRACK_GRADIENT }}>
          <SliderThumb
            style={{ backgroundColor: hsvToHex({ h: hsv.h, s: 100, v: 100 }) }}
          />
        </SliderTrack>
      </SliderControl>
    </Slider>
  );
}
